import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTabGroup} from '@angular/material';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {UsedBudgetService} from '../../../services/used-budget.service';
import {LoadingService} from '../../../services/loading.service';

@Component({
  selector: 'app-used-budget',
  templateUrl: './used-budget.component.html'
})
export class UsedBudgetComponent implements OnInit {
  @ViewChild('tabs', {static: false}) tabs: MatTabGroup;

  private pendingRequest: boolean;

  constructor(private toastMessagesService: ToastMessagesService,
              private usedBudgetService: UsedBudgetService,
              private loadingService: LoadingService) {
    this.pendingRequest = true;
  }

  public async ngOnInit(): Promise<void> {
    try {
      this.loadingService.show();
      // await this.usedBudgetService.fetchBudget();
      this.loadingService.hide();
    } catch (e) {
      this.loadingService.hide();
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.loadingService.hide();
      this.pendingRequest = false;
    }
  }
}
